import React from 'react'
import './App.css'
import './Profile.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { RiEditLine } from 'react-icons/ri'
import {
  IoPersonOutline,
  IoCardOutline,
  IoShareSocialOutline,
  IoDocumentTextOutline,
  IoRibbonOutline,
  IoLinkOutline,
  IoCopyOutline,
  IoCheckmarkCircle,
  IoEyeOutline,
  IoEyeOffOutline,
  IoGlobeOutline,
} from 'react-icons/io5'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { BiMenu } from 'react-icons/bi'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

/* Base of the public affiliate link */
const SHARE_BASE = 'https://karamale.com/?affiliateid='

/* Display-only helpers */
const Field = ({ label, children, wide }) => (
  <div className={`pf-field ${wide ? 'pf-field--wide' : ''}`}>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
)

/* On/off switch row */
const Switch = ({ checked, onChange, disabled, label, hint }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 16,
      padding: '14px 0',
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <div>
      <div style={{ fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 13, color: '#6b7280', marginTop: 2 }}>{hint}</div>
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        flex: 'none',
        width: 44,
        height: 24,
        borderRadius: 999,
        border: 'none',
        padding: 2,
        cursor: disabled ? 'not-allowed' : 'pointer',
        background: checked ? '#d91f2d' : '#cbd0d6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: checked ? 'flex-end' : 'flex-start',
        transition: 'background .15s',
      }}
    >
      <span
        style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff', display: 'block' }}
      />
    </button>
  </div>
)

const roleLabel = (accountType) =>
  accountType === 'partner'
    ? 'Affiliate'
    : accountType === 'customer'
      ? 'Attendee'
      : accountType === 'business'
        ? 'Organiser'
        : ''

/* profile_photo is stored as a relative path; full URLs pass through untouched */
const photoSrc = (path) => {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  return `${API_URL}/${String(path).replace(/^\/+/, '')}`
}

const partnerTypeLabel = (type) =>
  type === 'org' ? 'Organisation' : type === 'individual' ? 'Individual' : type || 'Not set'

const FOLLOWER_LABELS = { '500-2K': '500–2K', '2K-10K': '2K–10K' }
const followerLabel = (value) => FOLLOWER_LABELS[value] || value || 'Not added'

/* The database stores "approved"; older code used "verified". Accept both. */
const isVerified = (status) => {
  const s = String(status || '')
    .trim()
    .toLowerCase()
  return s === 'approved' || s === 'verified'
}

const VISIBILITY_MESSAGES = {
  saving: 'Saving…',
  saved: 'Saved',
  error: "Couldn't save. Try again.",
}

class Profile extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      errorDisplay: 'none',
      customername: '',
      businessname: '',
      affiliate: '',
      phone: '',
      email: '',
      dtregistered: '',
      bankname: '',
      account: '',
      accountnumber: '',
      branchcode: '',
      accountType: '',
      updated_at: '',
      // partner-only fields
      affiliateid: '',
      partner_type: '',
      profile_photo: '',
      bio: '',
      pitch: '',
      follower_estimate: '',
      verification_status: '',
      public_profile: true,
      show_contact: false,
      visibilityStatus: '',
      copied: false,
      showAccount: false,
      isMobile,
      collapsed: isMobile,
    }
    this.copyTimer = null
    this.visibilityTimer = null
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=ACCOUNTTYPE`, {
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          accountType: response.data.account_type,
        })
      })
      .catch((error) => {
        console.log(error)
      })

    if (localStorage.getItem('customername')) {
      const customername = localStorage.getItem('customername')
      const customerid = localStorage.getItem('customerid')
      document.title = customername + ' | Profile'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            customername: response.data.customername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            facebook: '',
            twitter: '',
            instagram: '',
            linkedin: '',
            tiktok: '',
            address: '',
            updated_at: response.data.updated_at,
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    } else if (localStorage.getItem('businessname')) {
      const businessname = localStorage.getItem('businessname')
      const businessid = localStorage.getItem('businessid')
      document.title = 'Profile - ' + businessname + ' - Businessname'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS&accountid=${businessid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            businessname: response.data.businessname ?? 'N/A',
            phone: response.data.phone ?? 'N/A',
            email: response.data.email ?? 'N/A',
            dtregistered: response.data.dtregistered ?? 'N/A',
            facebook: response.data.facebook ?? 'N/A',
            bankname: response.data.bankname ?? 'N/A',
            branchcode: response.data.branchcode ?? 'N/A',
            account: response.data.account ?? 'N/A',
            accountnumber: response.data.accountnumber ?? 'N/A',

            twitter: response.data.twitter ?? 'N/A',
            instagram: response.data.instagram ?? 'N/A',
            linkedin: response.data.linkedin || '',
            tiktok: response.data.tiktok || '',
            address: response.data.address ?? 'N/A',
            updated_at: response.data.updated_at ?? 'N/A',
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    } else {
      const partnername = localStorage.getItem('partnername')
      const partnerid = localStorage.getItem('partnerid')
      document.title = 'Karamale | Profile'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            affiliate: response.data.partnername || '',
            phone: response.data.phone || '',
            email: response.data.email || '',
            dtregistered: response.data.dtregistered || '',
            bankname: response.data.bankname || '',
            branchcode: response.data.branchcode ?? '',
            account: response.data.account || '',
            accountnumber: response.data.accountnumber || '',
            updated_at: response.data.updated_at || '',

            facebook: response.data.facebook || '',
            twitter: response.data.twitter || '',
            instagram: response.data.instagram || '',
            linkedin: response.data.linkedin || '',
            tiktok: response.data.tiktok || '',

            affiliateid: response.data.affiliateid || '',
            partner_type: response.data.partner_type || '',
            profile_photo: response.data.profile_photo || '',
            bio: response.data.bio || '',
            pitch: response.data.pitch || '',
            follower_estimate: response.data.follower_estimate || '',
            verification_status: response.data.verification_status || '',

            // defaults match the database: public on, contact hidden
            public_profile:
              response.data.public_profile === undefined || response.data.public_profile === null
                ? true
                : String(response.data.public_profile) === '1',
            show_contact: String(response.data.show_contact) === '1',
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
    if (this.copyTimer) clearTimeout(this.copyTimer)
    if (this.visibilityTimer) clearTimeout(this.visibilityTimer)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  handleCopy = (text) => {
    if (!text || !navigator.clipboard || !navigator.clipboard.writeText) return
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.setState({ copied: true })
        if (this.copyTimer) clearTimeout(this.copyTimer)
        this.copyTimer = setTimeout(() => this.setState({ copied: false }), 2000)
      })
      .catch(() => {})
  }

  /* Save public-profile switches. Optimistic; reverts if the save fails. */
  setVisibility = (patch) => {
    const prev = {
      public_profile: this.state.public_profile,
      show_contact: this.state.show_contact,
    }
    const next = { ...prev, ...patch }
    if (!next.public_profile) next.show_contact = false

    if (this.visibilityTimer) clearTimeout(this.visibilityTimer)
    this.setState({ ...next, visibilityStatus: 'saving' })

    const body = new URLSearchParams({
      public_profile: next.public_profile ? '1' : '0',
      show_contact: next.show_contact ? '1' : '0',
    })

    Axios.post(`${API_URL}/apps/kscanner/webservices.php?query=PARTNERVISIBILITY`, body, {
      withCredentials: true,
    })
      .then((res) => {
        if (!res.data || !res.data.ok) throw new Error('save failed')
        this.setState({ visibilityStatus: 'saved' })
        this.visibilityTimer = setTimeout(() => this.setState({ visibilityStatus: '' }), 2000)
      })
      .catch(() => {
        this.setState({ ...prev, visibilityStatus: 'error' })
      })
  }

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = this.state.affiliate
          dashboard = 'in'
        }
      } else {
        accountname = this.state.businessname
        dashboard = 'dashboard'
      }
    } else {
      accountname = this.state.customername
    }
    const customername = accountname
    const twitter = this.state.twitter

    const str = String(this.state.accountnumber || '00000000000')
    const last4 = str.slice(-4)
    const masked = '*'.repeat(str.length - 4) + last4

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    const social = (value) => (value === '' ? 'pf-link pf-link--muted' : 'pf-link')

    const isPartner = this.state.accountType === 'partner'
    const photo = isPartner ? photoSrc(this.state.profile_photo) : ''
    const verified = isVerified(this.state.verification_status)
    const shareLink = this.state.affiliateid ? SHARE_BASE + this.state.affiliateid : ''

    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}

        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}

        {this.state.isMobile && this.state.collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <main
          className="pf-page"
          style={{
            marginTop: 'var(--header-h)',
            marginLeft: this.state.isMobile ? 0 : this.state.collapsed ? '76px' : '252px',
          }}
        >
          <div className="pf-container">
            <div className="pf-top">
              <button type="button" className="pf-back" onClick={() => this.props.history.goBack()}>
                <IoIosArrowBack size={18} />
                <span>Back</span>
              </button>

              <Link
                to={{
                  pathname: 'editprofile',
                  state: {
                    accountname: customername,
                    email: this.state.email,
                    phone: this.state.phone,
                    dtregistered: this.state.dtregistered,
                    facebook: this.state.facebook,
                    twitter: this.state.twitter,
                    instagram: this.state.instagram,
                    address: this.state.address,
                    // partner-only
                    partner_type: this.state.partner_type,
                    profile_photo: this.state.profile_photo,
                    bio: this.state.bio,
                    pitch: this.state.pitch,
                    follower_estimate: this.state.follower_estimate,
                  },
                }}
                className="pf-edit"
              >
                <RiEditLine size={16} />
                Edit
              </Link>
            </div>

            {/* Identity card */}
            <section className="pf-hero">
              <div
                className="pf-avatar"
                style={photo ? { overflow: 'hidden', padding: 0 } : undefined}
              >
                {photo ? (
                  <img
                    src={photo}
                    alt={customername || 'Profile photo'}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: 'inherit',
                      display: 'block',
                    }}
                  />
                ) : (
                  (customername || '?').charAt(0).toUpperCase()
                )}
              </div>

              <div className="pf-hero__text">
                <h1>{customername}</h1>
                <p>{this.state.email}</p>
                {roleLabel(this.state.accountType) && (
                  <span className="pf-role">{roleLabel(this.state.accountType)}</span>
                )}
                {isPartner && (
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 4,
                      marginLeft: 8,
                      fontSize: 12,
                      fontWeight: 600,
                      color: verified ? '#0a8f4e' : '#6b7280',
                    }}
                  >
                    {verified && <IoCheckmarkCircle size={14} />}
                    {verified ? 'Verified' : 'Unverified'}
                  </span>
                )}
              </div>

              {/* {(this.state.accountType === 'business' || this.state.accountType === 'customer') && (
                <Link to="/b-details" className="pf-hero__link">
                  Bank Details
                </Link>
              )} */}

              {(this.state.accountType === 'business' || this.state.accountType === 'partner') && (
                <Link to="/b-details" className="pf-hero__link">
                  Bank Details
                </Link>
              )}
            </section>

            {/* My account */}
            <section className="pf-card">
              <div className="pf-card__head">
                <h2>
                  <IoPersonOutline size={18} />
                  My account
                </h2>
                <Link
                  to={{
                    pathname: '/changepassword',
                    state: {
                      credentials: 'password',
                    },
                  }}
                  className="pf-link"
                >
                  Change Password
                </Link>
              </div>

              <dl className="pf-grid">
                <Field
                  label={
                    this.state.accountType === 'partner'
                      ? 'Affiliate name'
                      : this.state.accountType === 'customer'
                        ? 'Name and surname'
                        : this.state.accountType === 'business'
                          ? 'Business name'
                          : 'Name and surname'
                  }
                >
                  {customername}
                </Field>
                <Field label="Email address">{this.state.email}</Field>
                <Field label="Phone number">{this.state.phone}</Field>
                <Field label="Account created">{this.state.dtregistered}</Field>
                <Field label="Updated on">{this.state.updated_at}</Field>
              </dl>
            </section>

            {/* About (partner only) */}
            {isPartner && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoDocumentTextOutline size={18} />
                    About
                  </h2>
                </div>

                <dl className="pf-grid">
                  <Field label="Bio" wide>
                    <span className="pf-preline">{this.state.bio || 'Bio not added'}</span>
                  </Field>
                  <Field label="Pitch" wide>
                    <span className="pf-preline">{this.state.pitch || 'Pitch not added'}</span>
                  </Field>
                </dl>
              </section>
            )}

            {/* Affiliate details (partner only) */}
            {isPartner && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoRibbonOutline size={18} />
                    Affiliate details
                  </h2>
                </div>

                <dl className="pf-grid">
                  <Field label="Affiliate type">{partnerTypeLabel(this.state.partner_type)}</Field>
                  <Field label="Follower estimate">
                    {followerLabel(this.state.follower_estimate)}
                  </Field>
                  <Field label="Verification">
                    {this.state.verification_status || (verified ? 'Verified' : 'Unverified')}
                  </Field>
                  <Field label="Affiliate ID">{this.state.affiliateid || 'N/A'}</Field>
                  <Field label="Your referral link" wide>
                    {shareLink ? (
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 8,
                          flexWrap: 'wrap',
                        }}
                      >
                        <IoLinkOutline size={16} />
                        <span style={{ wordBreak: 'break-all' }}>{shareLink}</span>
                        <button
                          type="button"
                          className="pf-link"
                          onClick={() => this.handleCopy(shareLink)}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: 0,
                          }}
                        >
                          {this.state.copied ? (
                            <IoCheckmarkCircle size={16} />
                          ) : (
                            <IoCopyOutline size={16} />
                          )}
                          {this.state.copied ? 'Copied' : 'Copy'}
                        </button>
                      </span>
                    ) : (
                      'N/A'
                    )}
                  </Field>
                </dl>
              </section>
            )}

            {/* Public profile (partner only) */}
            {isPartner && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoGlobeOutline size={18} />
                    Public profile
                  </h2>
                  {shareLink && this.state.public_profile && verified && (
                    <a
                      href={`/partner/${this.state.affiliateid}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pf-link"
                    >
                      View public profile
                    </a>
                  )}
                </div>

                <div style={{ padding: '4px 24px 20px' }}>
                  <Switch
                    checked={this.state.public_profile}
                    onChange={(v) => this.setVisibility({ public_profile: v })}
                    label="Show my profile publicly"
                    hint="Organisers who open your link can see your bio, followers and social links."
                  />
                  <div style={{ borderTop: '1px solid #eceef1' }}>
                    <Switch
                      checked={this.state.show_contact}
                      disabled={!this.state.public_profile}
                      onChange={(v) => this.setVisibility({ show_contact: v })}
                      label="Show my email and phone"
                      hint="Anyone with your link will be able to see them on your profile."
                    />
                  </div>

                  {!verified && (
                    <p style={{ fontSize: 13, color: '#6b7280', margin: '8px 0 0' }}>
                      Your public profile appears once your account is verified.
                    </p>
                  )}
                  <p
                    role="status"
                    style={{
                      fontSize: 13,
                      margin: '8px 0 0',
                      minHeight: 18,
                      color: this.state.visibilityStatus === 'error' ? '#b3141f' : '#6b7280',
                    }}
                  >
                    {VISIBILITY_MESSAGES[this.state.visibilityStatus] || ''}
                  </p>
                </div>
              </section>
            )}

            {/* Bank details (partner only) */}
            {this.state.accountType === 'partner' && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoCardOutline size={18} />
                    Bank details
                  </h2>
                  <Link to="/b-details" className="pf-link">
                    Add/Edit
                  </Link>
                </div>

                <dl className="pf-grid">
                  <Field label="Bank name">{this.state.bankname}</Field>
                  <Field label="Branch code">{this.state.branchcode}</Field>
                  <Field label="Account type">{this.state.account}</Field>
                  <Field label="Account number">
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                      <span>
                        {this.state.showAccount ? this.state.accountnumber || 'N/A' : masked}
                      </span>
                      <button
                        type="button"
                        aria-label={
                          this.state.showAccount ? 'Hide account number' : 'Show account number'
                        }
                        onClick={() =>
                          this.setState((prev) => ({ showAccount: !prev.showAccount }))
                        }
                        style={{
                          display: 'inline-flex',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          padding: 0,
                          color: 'inherit',
                        }}
                      >
                        {this.state.showAccount ? (
                          <IoEyeOffOutline size={18} />
                        ) : (
                          <IoEyeOutline size={18} />
                        )}
                      </button>
                    </span>
                  </Field>
                </dl>
              </section>
            )}

            {/* Social media (not for customers) */}
            {this.state.accountType !== 'customer' && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoShareSocialOutline size={18} />
                    Social media
                  </h2>
                </div>

                <dl className="pf-grid">
                  <Field label="Facebook">
                    <Link
                      to={{ pathname: this.state.facebook || '#' }}
                      target="_blank"
                      className={social(this.state.facebook)}
                    >
                      {this.state.facebook}
                    </Link>
                    {this.state.facebook === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="X/Twitter">
                    <Link
                      to={{
                        pathname: this.state.twitter,
                      }}
                      target="_blank"
                      className={social(this.state.twitter)}
                    >
                      {this.state.twitter}
                    </Link>
                    {this.state.twitter === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="Instagram">
                    <Link
                      to={{
                        pathname: this.state.instagram,
                      }}
                      target="_blank"
                      className={social(this.state.instagram)}
                    >
                      {this.state.instagram}
                    </Link>
                    {this.state.instagram === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="Linkedin">
                    <Link
                      to={{
                        pathname: this.state.linkedin,
                      }}
                      target="_blank"
                      className={social(this.state.linkedin)}
                    >
                      {this.state.linkedin}
                    </Link>
                    {this.state.linkedin === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="Tiktok">
                    <Link
                      to={{
                        pathname: this.state.tiktok || '#',
                      }}
                      target="_blank"
                      className={social(this.state.tiktok)}
                    >
                      {this.state.tiktok}
                    </Link>
                    {this.state.tiktok === '' ? 'Link not added' : ''}
                  </Field>

                  {this.state.accountType === 'business' ? (
                    <Field label="Business address" wide>
                      <span className="pf-preline">
                        {this.state.address == '' ? 'Address not added' : this.state.address}
                      </span>
                    </Field>
                  ) : (
                    ''
                  )}
                </dl>
              </section>
            )}
          </div>
        </main>

        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
      </div>
    )
  }
}

export default Profile
